<template>
  <el-card shadow="never" class="aui-card--fill">
	  <el-row style="background-color: #F3F4F4;">
			 <el-col :span="12" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;"><img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/wofangxinxi-icon.png" />参数管理</el-col>
			 <el-col :span="12">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-form-item>
					  <el-button v-if="$hasPermission('sys:params:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('sys:params:export')" type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>
					<el-form-item>
					  <el-button v-if="$hasPermission('sys:params:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
					</el-form-item>
				</el-form>
			 </el-col>
		</el-row>
    <div class="mod-sys__params">
      <el-form label-width="40px" style="padding-top: 20px;" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-row>
        	<el-col :md="10" :push="10">
				<el-form-item>
				  <el-input v-model="dataForm.paramCode" :placeholder="$t('params.paramCode')" clearable></el-input>
				</el-form-item>
			</el-col>
			<el-col :md="4" :push="10">
				<el-form-item>
				  <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
				</el-form-item>
			</el-col>
		</el-row>

      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="paramCode" :label="$t('params.paramCode')" header-align="center" align="center"></el-table-column>
        <el-table-column prop="paramValue" :label="$t('params.paramValue')" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" :label="$t('params.remark')" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:params:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:params:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
	  background
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './params-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/params/page',
        getDataListIsPage: true,
        deleteURL: '/sys/params',
        deleteIsBatch: true,
        exportURL: '/sys/params/export'
      },
      dataForm: {
        paramCode: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
